import React, { useState } from 'react';
import { ListItem } from '@material-tailwind/react';
import { ChevronDownIcon } from '@heroicons/react/outline';
import { Link } from 'react-router-dom';
import { Transition } from '@headlessui/react';

const MobileMenu = ({ mainTitle, subMenuItems, setIsParentMenuOpen }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <ListItem
        className='flex-col gap-2 py-2 font-medium text-gray-900'
        selected={isMobileMenuOpen}
        onClick={() => setIsMobileMenuOpen((curr) => !curr)}
      >
        <div className='flex gap-2 items-center'>
          {mainTitle}
          <ChevronDownIcon
            strokeWidth={3}
            className={`block h-3 w-3 transition-transform lg:hidden ${
              isMobileMenuOpen ? 'rotate-180' : ''
            }`}
          />
        </div>
      </ListItem>
      <Transition
        show={isMobileMenuOpen}
        enter='transition ease-out duration-100 transform'
        enterFrom='opacity-0 scale-95'
        enterTo='opacity-100 scale-100'
        leave='transition ease-in duration-75 transform'
        leaveFrom='opacity-100 scale-100'
        leaveTo='opacity-0 scale-95'
      >
        {(ref) => (
          <div className='md:hidden' id='mobile-menu'>
            <li
              ref={ref}
              className='px-2 pt-2 pb-3 space-y-1 sm:px-3 list-none'
            >
              {subMenuItems.map((subNavItem) => (
                <Link
                  to={subNavItem.link}
                  className='hover:bg-darkest block px-3 py-2 rounded-md text-base font-medium'
                  onClick={() => {
                    setIsMobileMenuOpen(!isMobileMenuOpen);
                    setIsParentMenuOpen(false);
                  }}
                >
                  {subNavItem.title}
                </Link>
              ))}
            </li>
          </div>
        )}
      </Transition>
    </>
  );
};

export default MobileMenu;
